<div class="desktop">
    {{note}}
</div>

<div class="mobile">
    {{note}}
</div>